import Quill from "quill";
const Parchment = Quill.import('parchment');
export class ShiftEnterBlot extends Parchment.Embed {} // Actually EmbedBlot

ShiftEnterBlot.blotName = 'shiftEnter';
ShiftEnterBlot.tagName = 'br';